import clsx from 'clsx';
import React from 'react';
import LoadingIcon from '../../assets/icons/loading-icon.svg?react';
import CheckGreenIcon from '../../assets/icons/check-green-icon.svg?react';
import HomeIcon from '../../assets/icons/home-icon.svg?react';
import Button from '../../components/Button';
import { useButtonSizeSmaller } from '../../utils/buttonSizes';
import { GetEstablishmentResponseDto } from '@EHSNavigator/backend';
interface CreateOshaReportStepFourProps {
  otherClasses?: string;
  establishment: GetEstablishmentResponseDto['establishment'];
}

const CreateOshaReportStepFour: React.FC<CreateOshaReportStepFourProps> = ({
  otherClasses,
  establishment,
}) => {
  const createOshaReportStepFourClasses = clsx(
    otherClasses,
    'flex-1 flex  flex-col items-center justify-center relative',
  );
  const sm = useButtonSizeSmaller();
  const isLogsNotAvailable = [21, 1].includes(establishment?.size || 0);

  return (
    <div
      className={createOshaReportStepFourClasses}
      data-testid="create-osha-report-step-four"
    >
      <div className="flex flex-col items-center gap-10">
        <div className="flex flex-col items-center gap-2.5 text-center">
          <LoadingIcon className="h-12 w-12 lg:h-85 lg:w-85" />
          <h3 className="text-neutral-tones-text font-ulagadi-sans font-semibold">
            OSHA Submission Successful
          </h3>
          <p className="text-neutral-tones-text font-inter-variable text-xl leading-6 font-normal italic">
            All reported injuries and illnesses have been successfully submitted
            to OSHA.
          </p>
        </div>
        <Button href="/dashboard" size={sm} otherClasses="">
          <HomeIcon className="h-5 w-5 [&>path]:fill-current" />
          Return Home
        </Button>
      </div>
      <div className="absolute bottom-12 left-0 flex w-full flex-wrap justify-center gap-x-9 gap-y-3">
        {!isLogsNotAvailable && (
          <p className="text-neutral-tones-text font-inter-variable flex items-center gap-2.5 text-lg leading-5 font-normal">
            <CheckGreenIcon className="[&>path]:fill-brand-fair-orange h-25 w-25" />
            OSHA 300 Form Submitted
          </p>
        )}
        <p className="text-neutral-tones-text font-inter-variable flex items-center gap-2.5 text-lg leading-5 font-normal">
          <CheckGreenIcon className="[&>path]:fill-brand-fair-orange h-25 w-25" />
          OSHA 300A Form Submitted
        </p>
      </div>
    </div>
  );
};

export default CreateOshaReportStepFour;
